import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import {addSuccessMessage} from "../SnackBar";

export const ASSOCIATIONS_PATCH_REQUEST = 'PATCH_ASSOCIATIONS_REQUEST';
export const ASSOCIATIONS_PATCH_FAILURE = 'PATCH_ASSOCIATIONS_FAILURE';
export const ASSOCIATIONS_PATCH_SUCCESS = 'PATCH_ASSOCIATIONS_SUCCESS';

export const patchAssociation = (data, id) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(patchRequest());
        return axios(apiRequestOptions(apiPath.ASSOCIATIONS.PATCH, data, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(patchSuccess(response.data));
                dispatch(addSuccessMessage('Association successfully changed'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchRequest = () => ({type: ASSOCIATIONS_PATCH_REQUEST});
const postFailure = error => ({type: ASSOCIATIONS_PATCH_FAILURE, error});
const patchSuccess = association => ({type: ASSOCIATIONS_PATCH_SUCCESS, association});